import React from 'react';
import { Hero, Story, Problem, Mistakes, Solution, Deliverables, Audience, HowItWorks, Proof, FAQ, Pricing } from './components/Sections';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen font-sans text-brand-dark selection:bg-brand-red selection:text-white" data-id="element-0">
      <main data-id="element-1">
        <Hero data-id="element-2" />
        <Story data-id="element-3" />
        <Problem data-id="element-4" />
        <Mistakes data-id="element-5" />
        <Solution data-id="element-6" />
        <Deliverables data-id="element-7" />
        <Audience data-id="element-8" />
        <HowItWorks data-id="element-9" />
        <Proof data-id="element-10" />
        <FAQ data-id="element-11" />
        <Pricing data-id="element-12" />
      </main>

      <Footer data-id="element-13" />
    </div>;
}